import { createApiRef } from '@backstage/frontend-plugin-api';

export type ProductVersion = {
  name: string;
  version: string;
  releaseDate: string;
  isLatest: boolean;
  changelog?: string;
  downloadUrl?: string;
};

export type ProductInfo = {
  id: string;
  name: string;
  description?: string;
  currentVersion: string;
  availableVersions: ProductVersion[];
  lastUpdated: string;
  metadata?: Record<string, any>;
};

export type ServiceData = {
  serviceName: string;
  serviceType: string;
  products: ProductInfo[];
  lastUpdated: string;
  totalProducts: number;
};

export type ProductsResponse = {
  services: ServiceData[];
};

export interface VersionsManagerApi {
  getProducts(): Promise<ProductsResponse>;
  getProductById(id: string): Promise<ProductInfo>;
  updateProductData(id: string, data: any): Promise<void>;
  refreshExternalData(serviceType?: string): Promise<{
    message: string;
    services: number;
    products: number;
  }>;
  upgrade(upgradeData: any): Promise<{
    message: string;
    webhookResponse?: any;
  }>;
}

export const versionsManagerApiRef = createApiRef<VersionsManagerApi>().with({
  id: 'plugin.versions-manager.api',
});
